import { message, Popconfirm } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteSession } from '../../../redux/Session/actions';

const DeleteSessionButton = ({ item }) => {
  const dispatch = useDispatch();
  
  const deleteEvent_fun = () => {
    dispatch(deleteSession(item._id));
    message.success("Deleted");
  };

  const confirm = () => {
    deleteEvent_fun();
  };

  return (
    <Popconfirm
      onConfirm={confirm}
      title="Êtes-vous sûr de vouloir supprimer ?"
      okText="Oui"
      cancelText="Non"
    >
      <a>Delete</a>
    </Popconfirm>
  );
};

export default DeleteSessionButton;
